import React from 'react';
import { useFetchFile } from '../../../hooks/useFetchFile.js';
import AuthorizedAction from '../../AuthorizedAction.js';
import { hideCIDataImportError } from '../../../modules/changeImpacts.js';
import { retrieveProject } from '../../../modules/projects.js';
import { connect } from 'react-redux';

const mapStateToProps = (state) => {
  return {
    apiUrl: state.config.apiUrl,
  };
};

const mapDispatchToProps = {
  retrieveProject,
  hideCIDataImportError,
};

function CiImportDataError({
  project,
  retrieveProject,
  hideCIDataImportError,
  apiUrl,
}) {
  const { downloadBlob } = useFetchFile();

  const onHideError = () => {
    if (!window.confirm('Are you sure you want to hide this error message?'))
      return;
    hideCIDataImportError(project.id).then(() => retrieveProject(project.id));
  };

  const onDownloadErrorsCsv = () => {
    downloadBlob(
      apiUrl,
      `projects/${project.id}/change_impacts/bulk_upload/errors_csv`,
      null,
      'errors-errors-import-data CSV',
      'csv'
    );
  };

  return project &&
    project.changeImpactUploadErrors &&
    project.changeImpactUploadErrors.error ? (
    <div className="component-xl component-border-bottom component-bg-white text-center">
      <div className="flex flex-end w-100">
        <button className="btn btn-default btn-cross" onClick={onHideError}>
          close
        </button>
      </div>
      <h3 className="flex text-danger flex-center m-b-12">
        There was an issue with Change Impacts CSV.
      </h3>
      <AuthorizedAction action="update" subject="organizationStakeholder">
        <p className="no-margin text-muted">
          An email with instructions has been sent to{' '}
          {project.changeImpactUploadErrors.user}. <br />
          Please, find CSV file with error
          <button
            type="button"
            className="btn-link"
            onClick={onDownloadErrorsCsv}
          >
            here
          </button>
          or in the email's attachments.
        </p>
      </AuthorizedAction>
    </div>
  ) : null;
}

export default connect(mapStateToProps, mapDispatchToProps)(CiImportDataError);
